import { PermissionCheckerService } from '@abp/auth/permission-checker.service';
import { Injector, ElementRef, Component, OnInit, AfterViewInit, ViewEncapsulation, Inject, HostBinding, ChangeDetectionStrategy, NgZone, ChangeDetectorRef } from '@angular/core';
import { AppComponentBase } from '@shared/common/app-component-base';
import { AppMenu } from './app-menu';
import { AppNavigationService } from './app-navigation.service';
import { DOCUMENT } from '@angular/common';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { LayoutRefService } from '@metronic/app/core/services/layout/layout-ref.service';
import { document } from 'ngx-bootstrap';

@Component({
    templateUrl: './side-bar-menu.component.html',
    selector: 'side-bar-menu',
    styleUrls: ['./side-bar-menu.component.less'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SideBarMenuComponent extends AppComponentBase implements OnInit, AfterViewInit {
    menu: AppMenu = null;
    currentRouteUrl = '';
    insideTm: any;
    outsideTm: any;

    constructor(
        injector: Injector,
        private el: ElementRef,
        private router: Router,
        private layoutRefService: LayoutRefService,
        public permission: PermissionCheckerService,
        private _appNavigationService: AppNavigationService,
        private changeDetector: ChangeDetectorRef,
        @Inject(DOCUMENT) private document: Document) {
        super(injector);
    }

    ngOnInit() {
        this.menu = this._appNavigationService.getMenu();

        this.currentRouteUrl = this.router.url.split(/[?#]/)[0];

        this.router.events
            .pipe(filter(event => event instanceof NavigationEnd))
            .subscribe(event => this.currentRouteUrl = this.router.url.split(/[?#]/)[0]);
    }

    gotToBuyAPolicy(): void {
        if (this.isDemoUser) {
            return;
        }
        this.router.navigate(['/app/main/MyCommandCentre/NewPolicy']).then(() => {
            this.changeDetector.detectChanges();
        });
    }

    isRoutedToBuyAPolicy(): boolean {
        if (this.currentRouteUrl.includes('NewPolicy')) {
            return true;
        }

        return false;
    }

    ngAfterViewInit(): void {
        setTimeout(() => {
            this.layoutRefService.addElement('asideLeft', this.el.nativeElement);
        });
    }

    showMenuItem(menuItem): boolean {
        let d = this._appNavigationService.showMenuItem(menuItem);
        return d;
    }

    hasOneVisibleSubItem(menuItem): boolean {
        return this._appNavigationService.hasOneVisibleSubItem(menuItem);
    }

    preventDefault(e: any): void {
        e.preventDefault();
    }

    removeSidebar() {
        let d = document.getElementById('m_aside_left');
        if (d.classList.contains('m-aside-left--on')) {
            d.classList.remove('m-aside-left--on');
            document.getElementsByClassName('m-aside-left-overlay')[0].classList.remove('m-aside-left-overlay');
        }
    }

    isMenuItemIsActive(item): boolean {
        if (item.items.length) {
            return this.isMenuRootItemIsActive(item);
        }

        if (!item.route) {
            return false;
        }

        // dashboard
        if (item.route !== '/' && this.currentRouteUrl.startsWith(item.route)) {
            return true;
        }

        return this.currentRouteUrl.replace(/\/$/, '') === item.route.replace(/\/$/, '');
    }

    isMenuRootItemIsActive(item): boolean {
        let result = false;

        for (const subItem of item.items) {
            result = this.isMenuItemIsActive(subItem);
            if (result) {
                return true;
            }
        }

        return false;
    }

    /**
     * Use for fixed left aside menu, to show menu on mouseenter event.
     * @param e Event
     */
    mouseEnter(e: Event) {

        if (!this.currentTheme.baseSettings.menu.allowAsideMinimizing) {
            return;
        }

        // check if the left aside menu is fixed
        if (this.document.body.classList.contains('m-aside-left--fixed')) {
            if (this.outsideTm) {
                clearTimeout(this.outsideTm);
                this.outsideTm = null;
            }

            this.insideTm = setTimeout(() => {
                // if the left aside menu is minimized
                if (this.document.body.classList.contains('m-aside-left--minimize') && mUtil.isInResponsiveRange('desktop')) {
                    // show the left aside menu
                    this.document.body.classList.remove('m-aside-left--minimize');
                    this.document.body.classList.add('m-aside-left--minimize-hover');
                }
            }, 300);
        }
    }

    /**
     * Use for fixed left aside menu, to show menu on mouseenter event.
     * @param e Event
     */
    mouseLeave(e: Event) {
        if (!this.currentTheme.baseSettings.menu.allowAsideMinimizing) {
            return;
        }

        if (this.document.body.classList.contains('m-aside-left--fixed')) {
            if (this.insideTm) {
                clearTimeout(this.insideTm);
                this.insideTm = null;
            }

            this.outsideTm = setTimeout(() => {
                // if the left aside menu is expand
                if (this.document.body.classList.contains('m-aside-left--minimize-hover') && mUtil.isInResponsiveRange('desktop')) {
                    // hide back the left aside menu
                    this.document.body.classList.remove('m-aside-left--minimize-hover');
                    this.document.body.classList.add('m-aside-left--minimize');
                }
            }, 500);
        }
    }
}
